import { observer } from 'mobx-react';
import { action, computed, observable } from 'mobx';
import * as React from 'react';
import { inject, bind } from '../../../../utils/decorators';
import { UiStore } from '../../../../stores/UiStore';
import { ApiStore } from '../../../../stores/ApiStore';
import { BpsReferenzkraftKalibrierungRili2021Store } from '../../../../stores/BpsReferenzkraftKalibrierungRili2021Store';
import * as ApiTypesBps from '../../../../models/ApiTypesBps2021';
import { Panel, Col, FormGroup, FormControl, ControlLabel, Table, InputGroup, Row } from 'react-bootstrap';
import { IBpsReferenzkraftMesswerteResponse } from '../../../../models/ApiTypesBps2021';
import BpsReferenzkraftVorbelastungRolle from './BpsReferenzkraftVorbelastungRolle';
import BpsReferenzkraftJustageInfo from './BpsReferenzkraftJustageInfo';
import Callout from '../../../site/Callout';
import BpsReferenzkraftGesamtBeurteilung from './BpsReferenzkraftGesamtBeurteilung';

interface IBpsReferenzkraftRollensatzMesspunktBeurteilungProps {
  position: string;
  index: number;
  nachJustage: boolean;
}

@observer
class BpsReferenzkraftRollensatzMesspunktBeurteilung extends React.Component<IBpsReferenzkraftRollensatzMesspunktBeurteilungProps, {}> {
  @inject(BpsReferenzkraftKalibrierungRili2021Store) store: BpsReferenzkraftKalibrierungRili2021Store;

  @computed get beurteilungMesspunkt() {
    const { position, index, nachJustage } = this.props;
    let quelle: ApiTypesBps.IBpsReferenzkraftRollensatz | null = null;
    if (position === 'links') {
      quelle = nachJustage ? this.store.datensatz.rollensatzJustage.links : this.store.datensatz.rollensatz.links;
    }
    if (position === 'rechts') {
      quelle = nachJustage ? this.store.datensatz.rollensatzJustage.rechts : this.store.datensatz.rollensatz.rechts;
    }
    if ((quelle !== null) && (quelle.messpunkte.length > index)) {
      if (quelle.messpunkte[index].beurteilung !== null) {
        return quelle.messpunkte[index].beurteilung === true ? 'i.O' : 'n.i.O';
      }
    }
    return '-';
  }

  render() {
    const beurteilung = this.beurteilungMesspunkt;
    let className = '';
    if (beurteilung !== null) {
      className = `beurteilung-${beurteilung.replace(/\./g, '').toLowerCase()}`;
    }
    return <div className={className}>{beurteilung}</div>;
  }
}

interface IBpsReferenzkraftRollensatzMessreiheProps {
  ziel: ApiTypesBps.IBpsReferenzkraftRollensatz;
  messreihe: number;
  nachJustage: boolean;
}

@observer
class BpsReferenzkraftRollensatzMessreihe extends React.Component<IBpsReferenzkraftRollensatzMessreiheProps, {}> {

  @inject(ApiStore) apiStore: ApiStore;
  @inject(BpsReferenzkraftKalibrierungRili2021Store) store: BpsReferenzkraftKalibrierungRili2021Store;

  @bind @action handleMesswertBpsChanged(index: number, ev: React.FormEvent<FormControl>) {
    this.props.ziel.messpunkte[index].messwerte[this.props.messreihe].bps = (ev.target as HTMLInputElement).valueAsNumber;
    this.store.berechneReferenzWerte();
  }

  @bind @action handleMesswertSensorChanged(index: number, ev: React.FormEvent<FormControl>) {
    this.props.ziel.messpunkte[index].messwerte[this.props.messreihe].sensor = (ev.target as HTMLInputElement).valueAsNumber;
    this.store.berechneReferenzWerte();
  }

  getMesswertBps(index: number) {
    const val = this.props.ziel.messpunkte[index].messwerte[this.props.messreihe].bps;
    return (val !== null) ? val : undefined;
  }

  getMesswertSensor(index: number) {
    const val = this.props.ziel.messpunkte[index].messwerte[this.props.messreihe].sensor;
    return (val !== null) ? val : undefined;
  }

  render() {
    const { ziel } = this.props;
    return (
      <div>
        <h4>Messreihe {this.props.messreihe + 1}</h4>
        <Table striped={false} bordered={false} condensed={true} hover={false} className="bps-auswertung">
          <thead>
            <tr>
                <th>Kraftstufe</th>
                <th>Messwert BPS</th>
                <th>Ref-Sensor</th>
                <th title="Referenzwert">RW</th>
                <th title="Mittelwertabweichung">MWA</th>
                <th style={{width: '48px'}}/>
            </tr>
          </thead>
          <tbody>
            {ziel.messpunkte.map((mp, index) =>
              <tr key={`mp-${index}`}>
                <td>{mp.anzeige}</td>
                <td>
                  <FormGroup style={{margin: '0px'}}>
                    <InputGroup>
                      <FormControl
                        type="number"
                        step="any"
                        onChange={(e) => this.handleMesswertBpsChanged(index, e)}
                        readOnly={this.store.readOnly}
                        value={this.getMesswertBps(index)}
                      />
                    </InputGroup>
                  </FormGroup>
                </td>
                <td>
                  <FormGroup style={{margin: '0px'}}>
                    <InputGroup>
                      <FormControl
                        type="number"
                        step="any"
                        onChange={(e) => this.handleMesswertSensorChanged(index, e)}
                        readOnly={this.store.readOnly}
                        value={this.getMesswertSensor(index)}
                      />
                    </InputGroup>
                  </FormGroup>
                </td>
                <td>{mp.messwerte[this.props.messreihe].referenzwert}</td>
                <td>{mp.messwerte[this.props.messreihe].messwertabweichung}</td>
                <td><BpsReferenzkraftRollensatzMesspunktBeurteilung position={ziel.position} index={index} nachJustage={this.props.nachJustage}/></td>
              </tr>
            )}
          </tbody>
        </Table>
      </div>
    );
  }
}

@observer
class BpsReferenzkraftRollensatz extends React.Component<{ ziel: ApiTypesBps.IBpsReferenzkraftRollensatz; rollenDurchmesser: number | null; nachJustage: boolean }, {}> {
  @inject(BpsReferenzkraftKalibrierungRili2021Store) store: BpsReferenzkraftKalibrierungRili2021Store;
  render() {
    const { ziel } = this.props;
    let header = 'Rollensatz ' + ziel.position;
    let zusatz = '';
    if (this.props.nachJustage) {
      zusatz = 'nach Justage';
    }
    return (
      <div>
        {/* Vorbelastung */}
        <Panel header={`${header} - Vorbelastung ${zusatz}`} collapsible={true} defaultExpanded={true}>
          <BpsReferenzkraftVorbelastungRolle ziel={ziel}/>
        </Panel>
        {/* Eingabe Messwerte */}
        <Panel header={`${header} - Messung ${zusatz}`} collapsible={true} defaultExpanded={true}>
          <BpsReferenzkraftRollensatzMessreihe messreihe={0} ziel={ziel} nachJustage={this.props.nachJustage}/>
          <BpsReferenzkraftRollensatzMessreihe messreihe={1} ziel={ziel} nachJustage={this.props.nachJustage}/>
          <BpsReferenzkraftRollensatzMessreihe messreihe={2} ziel={ziel} nachJustage={this.props.nachJustage}/>
        </Panel>
      </div>
    );
  }
}

/** Exportierte Komponente für die Messwerteingabe und -auswertung der BPS Rollensätze links und rechts nach 2021er Rili */
@observer
export default class BpsReferenzkraftRollensaetze extends React.Component<{}, {}> {

  @inject(UiStore) uiStore: UiStore;
  @inject(ApiStore) apiStore: ApiStore;
  @inject(BpsReferenzkraftKalibrierungRili2021Store) store: BpsReferenzkraftKalibrierungRili2021Store;

  @observable messpunkte: IBpsReferenzkraftMesswerteResponse = [];

  @bind @action setReferenzpunkte(referenzpunkte: IBpsReferenzkraftMesswerteResponse) {
    const { rollensatz } = this.store.datensatz;
    const anzahlReferenzpunkte = referenzpunkte.length;
    // Anzahl der Messpunkte der Rollensätze an Anzahl der Referenzmesspunkte anpassen
    if (referenzpunkte.length !== rollensatz.links.messpunkte.length || referenzpunkte.length || rollensatz.rechts.messpunkte.length) {
      var rollensaetze = [rollensatz.links, rollensatz.rechts];
      // Bei gewählter und aktiver Justage müssen auch die Messreihen für die Eingabe nach Justage angepasst werden
      if (this.store.datensatz.justageInfo === 'justage') {
        rollensaetze.push(this.store.datensatz.rollensatzJustage.links);
        rollensaetze.push(this.store.datensatz.rollensatzJustage.rechts);
      }
      rollensaetze.forEach(rs => {
        if (rs.messpunkte.length < referenzpunkte.length) {
          // Mehr Referenzpunkte als Messpunkte
          for (let i = rs.messpunkte.length; i < anzahlReferenzpunkte; i++) {
            rs.messpunkte.push({
              anzeige: 0,
              mittelwert: undefined,
              mittelwertabweichung: null,
              messunsicherheit: null,
              beurteilung: null,
              messwerte: [
                { bps: 0, sensor: null, referenzwert: null, messwertabweichung: null},
                { bps: 0, sensor: null, referenzwert: null, messwertabweichung: null},
                { bps: 0, sensor: null, referenzwert: null, messwertabweichung: null}
              ]
            });
          }
        } else if (rs.messpunkte.length > anzahlReferenzpunkte) {
          rs.messpunkte = rs.messpunkte.slice(0, anzahlReferenzpunkte);
        }
        // Daten aus Referenzpunkten übernehmen
        referenzpunkte.forEach((rp, index) => {
          rs.messpunkte[index].anzeige = rp.anzeige;
          // Messwerte BPS vorbelegen, erleichtert die Eingabe
          rs.messpunkte[index].messwerte.forEach((mp) => { mp.bps = rp.anzeige; });
        });
      });
    }
  }

  @bind @action async messpunkteAbrufen() {
    const { datensatz, kalibrierGegenstand } = this.store;
    if (kalibrierGegenstand && kalibrierGegenstand.objekt && datensatz.messbereich && datensatz.rollendurchmesser.mittelwert.links && datensatz.rollendurchmesser.mittelwert.rechts) {
      const response = await this.store.messpunkteAbrufen();
      if (response && response.ok) {
        this.setReferenzpunkte(response.json);
      }
    }
  }

  @bind @action handleMessbereichChanged(event: React.FormEvent<FormControl>) {
    this.store.setMessbereich((event.target as HTMLInputElement).value);
    this.messpunkteAbrufen();
  }

  @bind @action async handleMessbereichKleinChanged(event: React.FormEvent<FormControl>) {
    let val = parseFloat((event.target as HTMLInputElement).value);
    this.store.setMessbereichKlein(!isNaN(val) ? val : undefined);
    this.messpunkteAbrufen();
  }

  @bind @action handleMessbereichGrossChanged(event: React.FormEvent<FormControl>) {
    let val = parseFloat((event.target as HTMLInputElement).value);
    this.store.setMessbereichGross(!isNaN(val) ? val : undefined);
    this.messpunkteAbrufen();
  }

  renderOptionen() {
    const { datensatz, messbereiche } = this.store;
    return (
      <div>
        <FormGroup controlId="Messbereich">
          <Col componentClass={ControlLabel} sm={4}>Messbereich</Col>
          <Col sm={4}>
            <FormControl componentClass="select" placeholder="select" onChange={this.handleMessbereichChanged}  value={datensatz.messbereich} disabled={this.store.readOnly}>
              <option value="">Bitte auswählen...</option>
              <option value={'klein'}>Klein</option>
              <option value={'groß'}>Groß</option>
              <option value={'kombiniert'}>Kombiniert</option>
            </FormControl>
          </Col>
        </FormGroup>
        {(datensatz.messbereich === 'klein' || datensatz.messbereich === 'kombiniert')  &&
          <FormGroup controlId="Messbereich (klein)">
            <Col componentClass={ControlLabel} sm={4}>Messbereich (klein)</Col>
            <Col sm={4}>
              <FormControl componentClass="select" placeholder="select" onChange={this.handleMessbereichKleinChanged} value={datensatz.messbereichKlein ? datensatz.messbereichKlein.toString() : undefined} disabled={this.store.readOnly}>
                <option value="">Bitte auswählen...</option>
                {messbereiche.map(wert => <option key={wert} value={wert}>{wert} kN</option>)}
              </FormControl>
            </Col>
          </FormGroup>
        }
        {(datensatz.messbereich === 'groß' || datensatz.messbereich === 'kombiniert')  &&
          <FormGroup controlId="Messbereich (groß)">
            <Col componentClass={ControlLabel} sm={4}>Messbereich (groß)</Col>
            <Col sm={4}>
              <FormControl componentClass="select" placeholder="select" onChange={this.handleMessbereichGrossChanged} value={datensatz.messbereichGross ? datensatz.messbereichGross.toString() : undefined} disabled={this.store.readOnly}>
                <option value="">Bitte auswählen...</option>
                {messbereiche.map(wert => <option key={wert} value={wert}>{wert} kN</option>)}
              </FormControl>
            </Col>
          </FormGroup>
        }
      </div>
    );
  }

  render() {
    const { datensatz } = this.store;
    let mittelwerteVorhanden = true;
    if (!datensatz.rollendurchmesser.mittelwert.links || !datensatz.rollendurchmesser.mittelwert.rechts) {
      mittelwerteVorhanden = false;
    }
    return (
      <div>
        <Panel header="Kalibrierung Rollensätze - Messbereich" collapsible={true} defaultExpanded={true}>
          {/* Optionen */}
          {mittelwerteVorhanden ?
            this.renderOptionen()
            :
            <div className="text-muted">Die Auswahl der BPS-Daten ist erst nach Eingabe der Rollendurchmesser möglich</div>
          }
        </Panel>
        {(mittelwerteVorhanden && this.store.messbereichGueltig()) ?
          <div>
            <Row style={{maxWidth: '1600px !important'}}>
              <Col md={6} sm={12}><BpsReferenzkraftRollensatz ziel={datensatz.rollensatz.links} rollenDurchmesser={datensatz.rollendurchmesser.mittelwert.links} nachJustage={false}/></Col>
              <Col md={6} sm={12}><BpsReferenzkraftRollensatz ziel={datensatz.rollensatz.rechts} rollenDurchmesser={datensatz.rollendurchmesser.mittelwert.rechts} nachJustage={false}/></Col>
            </Row>
            <BpsReferenzkraftGesamtBeurteilung ziel={datensatz.gesamtErgebnis} nachJustage={false}/>
            <BpsReferenzkraftJustageInfo/>
            {(this.store.datensatz.justageInfo === 'justage') &&
              <div>
                <Row style={{maxWidth: '1600px !important'}}>
                  <Col md={6} sm={12}><BpsReferenzkraftRollensatz ziel={datensatz.rollensatzJustage.links} rollenDurchmesser={datensatz.rollendurchmesser.mittelwert.links} nachJustage={true}/></Col>
                  <Col md={6} sm={12}><BpsReferenzkraftRollensatz ziel={datensatz.rollensatzJustage.rechts} rollenDurchmesser={datensatz.rollendurchmesser.mittelwert.rechts} nachJustage={true}/></Col>
                </Row>
                <BpsReferenzkraftGesamtBeurteilung ziel={datensatz.rollensatzJustage.gesamtErgebnis} nachJustage={true}/>
              </div>
            }
          </div>
          :
          <Callout bsStyle="warning">
            Zur Messwerteingabe bitte Messbereiche auswählen.
          </Callout>
          }
      </div>
    );
  }

}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/vorlagen/bps/rili2021/BpsReferenzkraftRollensaetze.tsx